import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-35404299")

_pushScopeId("data-v-35404299")
const _hoisted_1 = { class: "bg-gradient flex justify-between" }
const _hoisted_2 = { class: "flex justify-start divide-x" }
const _hoisted_3 = { class: "menu-item bg-green-800" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "font-bold ml-1" }, "SCP", -1)
const _hoisted_6 = { class: "hidden lg:flex divide-x" }
const _hoisted_7 = { class: "menu-children" }
const _hoisted_8 = /*#__PURE__*/_createVNode("p", null, "Salir", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { class: "text-center text-2xl mb-6 text-primary" }, "Confirmar", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("p", { class: "text-center text-black font-light" }, "¿Está seguro que desea cerrar sesión en este dispositivo?", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "pt-6" }, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "bg-white absolute top-10 left-1/2 text-black p-5 rounded shadow-xl transform -translate-x-1/2 border border-gray-200 text-center",
  style: {"max-width":"300px","z-index":"9999999999999999"}
}
const _hoisted_13 = /*#__PURE__*/_createVNode("p", { class: "text-2xl mb-4" }, "Sesión por expirar", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("p", { class: "mb-3" }, "La sesión esta próxima a espirar, se recomienda volver a iniciar sesión", -1)
const _hoisted_15 = { class: "items-center justify-between px-3 py-2 hidden lg:flex bg-white" }
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "inline-block mr-3" }, "Cargando datos...", -1)
const _hoisted_17 = { class: "inline-block" }
const _hoisted_18 = { class: "flex items-center justify-end" }
const _hoisted_19 = {
  key: 0,
  style: {"text-align":"right"}
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Hola ")
const _hoisted_21 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" estás en Cancha ")
const _hoisted_23 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "px-2 pb-2 pt-8 md:pt-0 lg:px-6 relative container-app bg-white" }
const _hoisted_26 = {
  key: 0,
  class: "absolute top-14 left-1/2 bg-green-100 px-3 pb-2 transform -translate-x-1/2 rounded shadow-xl font-bold text-green-800 border-2 border-green-800 select-none"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ui_button = _resolveComponent("ui-button")
  const _component_ui_modal = _resolveComponent("ui-modal")
  const _component_login_form = _resolveComponent("login-form")
  const _component_fa_icon = _resolveComponent("fa-icon")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("p", _hoisted_4, [
            _createVNode("img", {
              src: require('@/assets/LOGO.jpg'),
              style: {"height":"25px","width":"auto"}
            }, null, 8, ["src"]),
            _hoisted_5
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.menu, (item) => {
            return (_openBlock(), _createBlock("div", {
              class: "menu-item menu-btn",
              key: item.name
            }, [
              _createVNode("div", {
                onClick: ($event: any) => (_ctx.routeHandler(item.route)),
                class: "w-full h-full"
              }, [
                _createVNode("p", null, _toDisplayString(item.name), 1)
              ], 8, ["onClick"]),
              _createVNode("div", _hoisted_7, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.children, (subitem) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "menu-child",
                    key: subitem.name,
                    onClick: ($event: any) => (_ctx.routeHandler(subitem.route))
                  }, [
                    _createVNode("p", null, _toDisplayString(subitem.name), 1)
                  ], 8, ["onClick"]))
                }), 128))
              ])
            ]))
          }), 128))
        ])
      ]),
      _createVNode("div", {
        class: "menu-item bg-green-800 cursor-pointer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalState = true))
      }, [
        _hoisted_8
      ]),
      _createVNode(_component_ui_modal, {
        modalState: _ctx.modalState,
        "onUpdate:modalState": _cache[3] || (_cache[3] = ($event: any) => (_ctx.modalState = $event))
      }, {
        default: _withId(() => [
          _hoisted_9,
          _hoisted_10,
          _hoisted_11,
          _createVNode(_component_ui_button, {
            label: "Cerrar Sesión",
            onClick: _ctx.signOut
          }, null, 8, ["onClick"]),
          _createVNode("p", {
            class: "text-center text-green-800 py-2 select-none cursor-pointer hover:bg-gray-50 rounded-md transition-all duration-300",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modalState = false))
          }, "Cancelar")
        ]),
        _: 1
      }, 8, ["modalState"]),
      (_ctx.modalStateLogin)
        ? (_openBlock(), _createBlock("div", _hoisted_12, [
            _hoisted_13,
            _hoisted_14,
            _createVNode(_component_login_form, { onLoginFn: _ctx.onLoginDone }, null, 8, ["onLoginFn"]),
            _createVNode("p", {
              class: "my-2 hover:bg-gray-100 py-1 rounded transition-all cursor-pointer",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onLoginDone && _ctx.onLoginDone(...args)))
            }, "Cancelar")
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_15, [
      _createVNode("div", {
        class: {
      'border-gray-200 border-2 shadow-xl p-2 m-2 rounded-xl text-gray-400 italic text-sm': true,
       'opacity-1': _ctx.getLoadingStatus,
       'opacity-0': !_ctx.getLoadingStatus
    }
      }, [
        _hoisted_16,
        _createVNode("span", _hoisted_17, [
          _createVNode(_component_fa_icon, {
            icon: ['fas', 'spinner'],
            spin: ""
          })
        ])
      ], 2),
      _createVNode("div", _hoisted_18, [
        (_ctx.user && _ctx.cancha)
          ? (_openBlock(), _createBlock("p", _hoisted_19, [
              _hoisted_20,
              _createVNode("strong", null, _toDisplayString(_ctx.user.nombre), 1),
              _hoisted_21,
              _hoisted_22,
              _hoisted_23,
              _createVNode("strong", null, [
                (_ctx.cancha && _ctx.cancha._id !== 'ALL')
                  ? (_openBlock(), _createBlock("span", _hoisted_24, _toDisplayString(_ctx.cancha.codigo), 1))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(_ctx.cancha.descripcion), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("img", {
          src: require('@/assets/LOGO.jpg'),
          style: {"height":"100px","width":"auto","margin-left":"10px"}
        }, null, 8, ["src"])
      ])
    ]),
    _createVNode("div", _hoisted_25, [
      (_ctx.mustReload)
        ? (_openBlock(), _createBlock("div", _hoisted_26, " HAY NUEVOS DATOS, DEBES RECARGAR EL NAVEGADOR "))
        : _createCommentVNode("", true),
      _createVNode(_component_router_view)
    ])
  ], 64))
})